/** The server's error key in the reader's language. */
export const errorText = (t, error) => {
  const key = error?.response?.data?.message || error?.response?.data?.error || error?.message || '';
  return t(`errors.${key.replace(/^partner_request\./, '')}`, { defaultValue: t('errors.generic') });
};

export const STATUS_COLORS = {
  pending: 'default',
  queued: 'processing',
  sent: 'blue',
  delivered: 'green',
  failed: 'red',
  bounced: 'red',
  complaint: 'magenta',
  blocked: 'orange',
};

export const REPLY_COLORS = { replied: 'blue', repliedWithAttachment: 'green' };

/** Where an address stands: missing, proposed, confirmed or left out. */
export const addressStateOf = (r) => {
  if (r.excluded) return 'excluded';
  if (!r.emails.length) return 'missing';
  return r.addressConfirmedAt ? 'confirmed' : 'proposed';
};

export const ADDRESS_STATE_COLORS = { excluded: 'default', missing: 'red', proposed: 'gold', confirmed: 'green' };
